import { alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

interface MediaStylesOptions {
  imageAspectRatioPadding?: string;
}

export const catalogBannerAspectRatioPadding = '125%';
export const imageAspectRatioPadding = '160%'; // 16:10
export const myNetworkCardAspectRatioPadding = '55.653%'; // ~1.8;
export const bannerAspectRatioPadding = '21.875%'; // 32/7;
export const mobileBannerAspectRatioPadding = '56.25%'; // 16:9

export const buildMediaActionStyles = () => ({
  '& .ActionButton': {
    zIndex: 998,
    transition: 'opacity 0.2s ease-out',
  },
  '&:hover': {
    '& .ActionButton': {
      opacity: 1,
    },
  },
});

const useMediaStyles = makeStyles<MediaStylesOptions>()((theme, props) => ({
  root: {
    borderRadius: theme.shape.borderRadius,
    width: '100%',
    position: 'relative',
    ...buildMediaActionStyles(),
    [theme.breakpoints.up('sm')]: {
      '& .ActionButton': {
        opacity: 0,
      },
    },
  },

  mediaControlsTop: {
    position: 'absolute',
    top: theme.spacing(1),
    left: theme.spacing(1),
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    pointerEvents: 'none',
    '& > *': {
      pointerEvents: 'all',
    },
  },

  mediaBoxWithAspectRatio: {
    width: '100%',
    overflow: 'hidden',
    paddingTop: props?.imageAspectRatioPadding || imageAspectRatioPadding,
    position: 'relative',
  },

  mediaBoxWithoutAspectRatio: {
    width: '100%',
    height: '100%',
    position: 'relative',
  },

  mediaContentCover: {
    position: 'absolute',
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    top: 0,
    left: 0,
  },

  mediaContentContain: {
    position: 'absolute',
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    top: 0,
    left: 0,
  },

  dropzoneGridContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '160px',
  },

  dropzoneGridIcon: {
    width: '64px',
    height: '64px',
  },

  dropzoneAddButtonFill: {
    width: '100%',
    height: '100%',
  },

  disabledMediaOverlay: {
    '&::after': {
      content: '""',
      position: 'absolute',
      inset: 0,
      backgroundColor: alpha(theme.palette.accent.dark, 0.5),
    },
  },
}));

export default useMediaStyles;
